import { Button, Row, Col } from "antd";
import { StartupCard, StartupWrapper } from "./styles";
import { useAppSelector, useThemeColors } from "redux/hooks";
import VELOCITY from "components/icons/brand/VELOCITY";
import { useAuth } from "react-oidc-context";

const Startup = ({ message, showReload }: { message: string, showReload: boolean }) => {
  const app = useAppSelector(state => state.app);
  const themeColors = useThemeColors();

  const reload = () => {
    sessionStorage.removeItem("velocity:customerConfig");
    window.location.reload();
  }

  return (
    <StartupWrapper>
      <StartupCard>
        <Row>
          <Col span={24}>
            <div style={{ textAlign: "center" }}>
              <VELOCITY width={324} height={104} color={themeColors.primaryColor} />
            </div>
          </Col>
        </Row>
        <div style={{ textAlign: "center", color: "var(--text-color-muted, #999)" }}>{message}</div>
        {showReload &&
          <div style={{ textAlign: "center", marginTop: "0.5em" }}>
            <Button type="primary" title="Reload the current page" htmlType="submit" onClick={reload}>Reload</Button>
          </div>
        }
      </StartupCard>
    </StartupWrapper>
  );
};

export default Startup;
